import React from 'react'
import Header from '../compontents/Header'
import HeroSection from '../compontents/HeroSection'
import Footer from '../compontents/Footer'
import WhyUs from '../compontents/WhyUs'
import Stats from '../compontents/Stats'

const HomePage = () => {
  return (
    <React.Fragment>
      <Header />
      <HeroSection />
      <WhyUs />
      <Stats />
      <Footer />
    </React.Fragment>
  )
}

export default HomePage